// ---------- Counter Actions ----------
export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";

export const increment = () => ({ type: INCREMENT });
export const decrement = () => ({ type: DECREMENT });

// ---------- Async (Thunk) ----------
export const incrementAsync = (delay = 1000) => (dispatch) => {
  setTimeout(() => dispatch(increment()), delay);
};

export const decrementAsync = (delay = 1000) => (dispatch) => {
  setTimeout(() => dispatch(decrement()), delay);
};
